"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedCheckbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var Check_svg_1 = __importDefault(require("../assets/svgs/Check.svg"));
var StyledIcon = (0, styles_1.styled)('span')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 20,
        height: 20,
        padding: 2,
        border: 'solid',
        borderWidth: 2,
        borderRadius: 4,
        borderColor: theme.palette.primary[300],
        backgroundColor: 'transparent',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:disabled ~ &': {
            background: theme.palette.primary[300],
        },
    });
});
var StyledCheckedIcon = (0, styles_1.styled)(StyledIcon)(function (_a) {
    var theme = _a.theme;
    return ({
        borderColor: theme.palette.secondary.main,
        backgroundColor: theme.palette.secondary.main,
        '&:before': {
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            display: 'block',
            width: 12,
            height: 12,
            backgroundImage: "url(".concat(Check_svg_1.default, ")"),
            content: '""',
        },
    });
});
var ThemedCheckbox = function (props) {
    return ((0, jsx_runtime_1.jsx)(Checkbox_1.default, __assign({ className: "checkbox", disableRipple: true, color: "secondary", checkedIcon: (0, jsx_runtime_1.jsx)(StyledCheckedIcon, {}), icon: (0, jsx_runtime_1.jsx)(StyledIcon, {}), sx: {
            padding: '12px',
            paddingTop: '0.9rem',
            paddingBottom: '0.9rem',
        }, inputProps: { 'aria-label': 'Checkbox' } }, props)));
};
exports.ThemedCheckbox = ThemedCheckbox;
